import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-location-list-entry-skeleton',
  templateUrl: './location-list-entry-skeleton.html',
  imports: [Skeleton],
})
export class LocationListEntrySkeleton {}
